import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import { Alert, Snackbar } from '@mui/material';
import { Clear, Delete, Edit, Add } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import AuthContext from '../../../../store/AuthContext';
import DataGridContext from '../../../../store/DataGridContext';
import ModalContext from '../../../../store/ModalContext';

const EMPTY_ARRAY = [];

const renderTooltipCell = (value, maxLen) => {
  const text = String(value || '');
  const isTruncated = text.length > maxLen;
  const truncatedText = isTruncated ? text.slice(0, maxLen).trimEnd() + '...' : text;

  const content = (
    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: "pointer" }}>
      {truncatedText}
    </span>
  );

  return isTruncated ? (
    <Tooltip
      title={text}
      placement="top"
      arrow
      componentsProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -4],
              },
            },
          ],
        },
      }}
    >
      {content}
    </Tooltip>
  ) : content;
};

const processCol = (col) => {
  const fieldLower = col.field?.toLowerCase() || '';
  if (fieldLower === 'course name' || fieldLower === 'course_name' || fieldLower === 'course') {
    col.renderCell = (params) => renderTooltipCell(params.value, 20);
  } else if (fieldLower === 'coupon code' || fieldLower === 'coupon' || fieldLower === 'code') {
    col.renderCell = (params) => renderTooltipCell(params.value, 12);
  }
  return col;
};

const CouponsTab = ({
  index,
  item,
  currentTabId,
  tabValue,
  TabPanel,
  selectionModel,
  setSelectionModel,
  isBulkDeleting,
  bulkDeleteCoupons,
  DataGridState,
  datagridPage,
  setDatagridPage,
  tabs,
  setTotalRecords,
  assessmentId: assessmentIdProp,
  mode = 'assessment',
  courses = EMPTY_ARRAY,
}) => {

  const assessmentId = mode === 'course' ? assessmentIdProp : (assessmentIdProp || item?.assessmentId);
  console.log("currentTabId:", currentTabId);
  const datagridCtx = useContext(DataGridContext);
  const modalCtx = useContext(ModalContext);

  const authCtx = useContext(AuthContext);

  const [totalRecordsLocal, setTotalRecordsLocal] = useState(0);
  const [coupons, setCoupons] = useState([]);
  const [usersCols, setUsersCols] = useState([]);
  const [usersRows, setUsersRows] = useState(null);
  const [bundle, setBundle] = useState(null);
  const [localCourses, setLocalCourses] = useState([]);

  const [usersRowsMod, setUsersRowsMod] = useState([]);

  const [filterInputValue, setFilterInputValue] = useState("");
  const [filteredRow, setFilteredRow] = useState();
  const [fetchingCoupons, setFetchingCoupons] = useState(true);
  const [isBulkDeletingCourse, setIsBulkDeletingCourse] = useState(false);
  const [toastInfo, setToastInfo] = useState({
    isOpen: false,
    isSuccess: false,
    msg: ""
  })

  console.log(filteredRow, usersRowsMod)
  useEffect(() => {
    setUsersRowsMod(usersRows || []);
  }, [usersRows]);

  useEffect(() => {
    const searchText = filterInputValue?.toLowerCase() || "";
    const val = usersRows?.filter((item) =>
      Object.values(item).some((value) =>
        String(value || "").toLowerCase().includes(searchText)
      )
    );
    setFilteredRow(val);
    if (typeof setTotalRecords === 'function') {
      setTotalRecords(val?.length ?? 0, currentTabId);
    }
    setTotalRecordsLocal(val?.length ?? 0);
  }, [filterInputValue, usersRows]);

  useEffect(() => {
    if (datagridCtx?.filteredDataGridUsers) {
      setTotalRecordsLocal(datagridCtx.filteredDataGridUsers.length)
    }
    else {
      setTotalRecordsLocal(filteredRow?.length || 0)
    }
  }, [datagridCtx.filteredDataGridUsers]);

  const fetchCoupons = async () => {
    setFetchingCoupons(true);

    if (mode === 'course') {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URI}/v8/admin/assessment/${assessmentId}/coupons`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authCtx.token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        const rows = Array.isArray(data?.data?.coupons) ? data.data.coupons : [];

        const mapped = rows.map(c => ({
          id: c.id,
          "Coupon Code": c.coupon,
          "Course Name": c.course_name,
          courseId: c.course_id,
          Discount: c.discount_percentage,
          "Usage Limit": c.usage_limit,
          "Times Used": c.times_used,
          Status: c.coupon_status === 'limit_reached'
            ? 'limit reached'
            : c.coupon_status === 'inactive'
              ? 'inactive'
              : 'active',
          Created: c.created_at,
        }));

        setCoupons(mapped);
        if (setTotalRecords) setTotalRecords(mapped.length, currentTabId);
        setTotalRecordsLocal(mapped.length);

        const mappedCols = Object.keys(mapped[0] || {}).map((key) => processCol({
          field: key,
          headerName: key,
          width: key === 'Course Name' ? 220 : 150,
        }));
        mappedCols.push({
          field: 'actions',
          headerName: 'Actions',
          width: 100,
          sortable: false,
          disableColumnMenu: true,
          renderCell: (params) => (
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
              <Tooltip title="Edit Coupon">
                <Edit
                  style={{ cursor: 'pointer', color: '#122845', fontSize: '20px' }}
                  onClick={() => handleEditCoupon(params.row)}
                />
              </Tooltip>
            </div>
          ),
        });

        setUsersCols(mappedCols);
        setUsersRows(mapped);
        setUsersRowsMod(mapped);
      } catch (err) {
        console.error('Failed to fetch course coupons:', err);
        setUsersRows([]);
        setUsersRowsMod([]);
      } finally {
        setFetchingCoupons(false);
      }
      return;
    }

    const envURI = process.env.REACT_APP_API_URI;
    const URL = `${envURI}/v6/admin/assessment/${assessmentId}/tab/${currentTabId}/view/coupons`;
    try {
      const response = await fetch(URL, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${authCtx.token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Fetch Coupons API response:", response);
      const data = await response.json();
      console.log("Fetch Coupons API data:", data);
      const isSuccess = data?.status === "success" || data?.statusText === "Success";
      const rows = Array.isArray(data?.data) ? data.data : [];
      if (isSuccess) {
        setCoupons(rows);
        setTotalRecords(rows.length, currentTabId);
        setTotalRecordsLocal(rows.length);

        let mappedCols = [];
        if (Array.isArray(data?.fields) && data.fields.length > 0) {
          mappedCols = data.fields.map((col) => processCol({
            field: col.field,
            headerName: col.field,
            width: col.width || 180,
          }));
        } else if (rows.length > 0) {
          const first = rows[0];
          mappedCols = Object.keys(first).map((key) => processCol({
            field: key,
            headerName: key,
            width: 180,
          }));
        }

        const columnsWithActions = [
          ...mappedCols,
          {
            field: "actions", headerName: "Actions", width: 150, sortable: false, pinned: 'right', disableColumnMenu: true,
            renderCell: (params) => (
              <div style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'center' }}>
                <Tooltip title="Edit Coupon">
                  <Edit
                    style={{ cursor: 'pointer', color: '#122845', fontSize: '20px' }}
                    onClick={() => handleEditCoupon(params.row)}
                  />
                </Tooltip>
              </div>
            ),
          },
        ];
        setUsersCols(columnsWithActions);

        const sorted = rows.slice().sort((a, b) => {
          const dateA = a.Date || a.date;
          const dateB = b.Date || b.date;
          if (!dateA || !dateB) return 0;
          const timeA = new Date(dateA).getTime();
          const timeB = new Date(dateB).getTime();
          if (Number.isNaN(timeA) || Number.isNaN(timeB)) return 0;
          return timeB - timeA;
        });

        const normalized = sorted.map((row, index) => ({
          ...row,
          id: row?.id ?? row?.ID ?? row?.coupon ?? row?.code ?? `coupon-${index}`
        }));
        setUsersRows(normalized);
        setUsersRowsMod(normalized);
        console.log("Coupons fetched successfully");
      } else {
        console.error("Failed to fetch coupons");
        setUsersRows([]);
        setUsersRowsMod([]);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      setUsersRows([]);
      setUsersRowsMod([]);
    } finally {
      setFetchingCoupons(false);
    }
  };

  const fetchBundle = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URI}/v8/admin/assessment/${assessmentId}/bundle`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authCtx.token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      if (!response.ok) {
        setBundle(null);
        return;
      }
      const data = await response.json();
      setBundle(data?.data?.bundle || null);
    } catch (err) {
      console.error('Failed to fetch bundle:', err);
      setBundle(null);
    }
  };

  useEffect(() => {
    if (courses && courses.length > 0) {
      setLocalCourses(courses);
    } else if (assessmentId) {
      const fetchCourses = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URI}/v8/admin/assessment/${assessmentId}/courses`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authCtx.token}`,
                'Content-Type': 'application/json',
              },
            }
          );
          if (!response.ok) return;
          const data = await response.json();
          if (data.statusText === 'Success') {
            const mapped = data.data.courses.map(course => ({
              id: course.id,
              name: course.title,
              description: course.description,
              thumbnail_url: course.thumbnail_url,
              date: course.created_at?.split(' ')[0],
              created_at: course.created_at,
              status: course.is_active === 1 ? 'Active' : 'Inactive',
              price: course.price,
            }));
            setLocalCourses(mapped);
          }
        } catch (err) {
          console.error('Failed to fetch courses:', err);
        }
      };
      fetchCourses();
    }
  }, [courses, assessmentId, authCtx.token]);

  useEffect(() => {
    if (mode === 'course') {
      fetchCoupons();
      fetchBundle();
      return;
    }
    console.log("CouponsTab isActiveTab check:", { currentTabId, itemId: item?.id });
    const isActiveTab = String(currentTabId) === String(item?.id);
    console.log("CouponsTab isActiveTab result:", isActiveTab);
    if (isActiveTab) {
      fetchCoupons();
    }
  }, [assessmentId, currentTabId, authCtx.token, tabs, mode, item]);

  const handleCreateCoupon = () => {
    modalCtx.setDetails("create-edit-coupon-modal", {
      assessmentId: assessmentId,
      currentTabId: currentTabId,
      mode: mode,
      courses: localCourses,
      refreshCoupons: fetchCoupons,
      showToast: (toastData) => {
        setToastInfo(toastData);
        setTimeout(() => {
          setToastInfo(prev => ({ ...prev, isOpen: false }));
        }, toastData.isSuccess ? 2000 : 3000);
      }
    });
    modalCtx.openModal();
  };

  const handleEditCoupon = (coupon) => {
    modalCtx.setDetails("create-edit-coupon-modal", {
      coupon,
      couponId: coupon?.id,
      assessmentId: assessmentId,
      currentTabId: currentTabId,
      mode: mode,
      courses: localCourses,
      refreshCoupons: fetchCoupons,
      showToast: (toastData) => {
        setToastInfo(toastData);
        setTimeout(() => {
          setToastInfo(prev => ({ ...prev, isOpen: false }));
        }, toastData.isSuccess ? 2000 : 3000);
      }
    });
    modalCtx.openModal();
  };

  const handleDeleteCoupon = (coupon) => {
    modalCtx.setDetails("delete-coupon-confirmation", {
      coupon: coupon,
      assessmentId: assessmentId,
      currentTabId: currentTabId,
      mode: mode,
      refreshCoupons: fetchCoupons,
      showToast: (toastData) => {
        setToastInfo(toastData);
        setTimeout(() => {
          setToastInfo(prev => ({ ...prev, isOpen: false }));
        }, toastData.isSuccess ? 2000 : 3000);
      }
    });
    modalCtx.openModal();
  };

  const showToast = (toastData) => {
    setToastInfo(toastData);
    setTimeout(() => {
      setToastInfo(prev => ({ ...prev, isOpen: false }));
    }, toastData.isSuccess ? 2000 : 3000);
  };

  const handleCourseBulkDelete = async () => {
    if (!selectionModel || selectionModel.length === 0) return;

    const firstRow = usersRows?.find(r => r.id === selectionModel[0]);
    const courseId = firstRow?.courseId;

    if (!courseId) {
      showToast({ isOpen: true, isSuccess: false, msg: 'No valid coupons selected for deletion.' });
      return;
    }

    setIsBulkDeletingCourse(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URI}/v8/admin/assessment/${assessmentId}/courses/${courseId}/coupons`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${authCtx.token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ couponIds: selectionModel }),
        }
      );

      if (!response.ok) {
        showToast({ isOpen: true, isSuccess: false, msg: 'Failed to delete selected coupons.' });
        return;
      }

      const data = await response.json();
      if (data?.statusText === 'Success') {
        showToast({
          isOpen: true,
          isSuccess: true,
          msg: `${selectionModel.length} coupon${selectionModel.length !== 1 ? 's' : ''} deleted successfully.`,
        });
        setSelectionModel([]);
        await fetchCoupons();
      } else {
        showToast({ isOpen: true, isSuccess: false, msg: 'Failed to delete selected coupons.' });
      }
    } catch (err) {
      console.error('Bulk delete error:', err);
      showToast({ isOpen: true, isSuccess: false, msg: 'An error occurred while deleting coupons.' });
    } finally {
      setIsBulkDeletingCourse(false);
    }
  };

  const handleEditBundlePrice = () => {
    modalCtx.openModal();
    modalCtx.setDetails("edit-bundle-price-modal", {
      bundle: bundle,
      assessmentId: assessmentId,
      courses: localCourses,
      onSave: (savedBundle) => setBundle(savedBundle),
    });
  };

  return (
    <div>
      <TabPanel index={index} value={tabValue} className="users-table">
        <div className="header-tool-bar" style={{ justifyContent: 'space-between' }}>
          <div className="search-bar">
            <input type="search" name="" id="search-field"
              className="search-field" placeholder="Type to search..."
              value={filterInputValue}
              onChange={(e) => setFilterInputValue(e.target.value)}
            />
            {filterInputValue && <Clear className="clear-search-icon" onClick={() => setFilterInputValue("")} />}
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {mode === 'course'
              ? (selectionModel.length > 0 || isBulkDeletingCourse) && (
                isBulkDeletingCourse
                  ? <Button className="bulk-delete-btn black-btn" style={{ padding: "5px 10px", maxHeight: "36px", alignSelf: "center" }}>
                    <CircularProgress style={{ 'color': '#fff' }} size={15} />&nbsp;&nbsp;Deleting
                  </Button>
                  : <Button className="bulk-delete-btn black-btn" style={{ padding: "5px 10px", maxHeight: "36px", alignSelf: "center" }} onClick={handleCourseBulkDelete}>
                    <Delete /> Delete
                  </Button>
              )
              : (selectionModel.length > 0 || isBulkDeleting) && (
                <>{isBulkDeleting
                  ? <Button className="bulk-delete-btn black-btn" style={{ padding: "5px 10px", maxHeight: "36px", alignSelf: "center" }}>
                    <CircularProgress style={{ 'color': '#fff' }} size={15} />&nbsp;&nbsp;Deleting
                  </Button>
                  : <Button className="bulk-delete-btn black-btn" style={{ padding: "5px 10px", maxHeight: "36px", alignSelf: "center" }} onClick={() => bulkDeleteCoupons(setUsersRows)}>
                    <Delete /> Delete
                  </Button>
                }</>
              )
            }
            {mode === 'course' && localCourses && localCourses.length > 0 && (
              <Button
                className="edit-bundle-price"
                style={{ padding: "5px 12px", maxHeight: "36px", alignSelf: "center", marginBottom: "15px", textTransform: "none", width: "165px" }}
                onClick={handleEditBundlePrice}
              >
                {bundle ? <Edit style={{ fontSize: '18px' }} /> : <Add />}
                {bundle ? "Edit Bundle" : "Add a Bundle"}
              </Button>
            )}

            <Button className="black-btn" style={{ padding: "5px 15px", maxHeight: "36px", alignSelf: "center", marginBottom: "15px" }} onClick={handleCreateCoupon} >
              <Add /> Create Coupon
            </Button>
          </div>
        </div>
        {
          fetchingCoupons ? (
            <Box className="loader-section" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
              <CircularProgress />
            </Box>
          ) : (usersRows && usersRows.length >= 0) ?
            <DataGrid
              rows={filterInputValue.length === 0 ? usersRowsMod : filteredRow}
              columns={usersCols}
              components={{
                Toolbar: DataGridState,
              }}
              pagination
              rowCount={totalRecordsLocal}
              pageSize={50}
              page={datagridPage}
              onPageChange={(newPage) => setDatagridPage(newPage)}
              onColumnVisibilityModelChange={(change) => console.log("columnVisibilityModelChange", change)}
              columnVisibilityModel={{
                id: false,
                courseId: false,
                "User ID": false,
              }}
              checkboxSelection
              onFilterModelChange={(filter, details) => { console.log("filter", filter, details) }}
              selectionModel={selectionModel}
              onSelectionModelChange={(newSelectionModel) => {
                console.log("filter", newSelectionModel);
                let rows_ids = (filterInputValue.length === 0 ? usersRowsMod : filteredRow).map(row => row.id)
                if (rows_ids.length <= 50) {
                  setSelectionModel(newSelectionModel)
                }
                else {
                  if (newSelectionModel.length === rows_ids.length && selectionModel.length === 0) {
                    rows_ids = Array.from({ length: Math.ceil((rows_ids || []).length / 50) }, (_, i) => rows_ids.slice(i * 50, i * 50 + 50))
                    setSelectionModel(rows_ids[datagridPage]);
                  }
                  else {
                    setSelectionModel(newSelectionModel)
                  }
                }
              }}
              disableSelectionOnClick
              rowsPerPageOptions={[100]}
            /> :
            (
              <Box className="loader-section" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
                <CircularProgress />
              </Box>
            )
        }
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={toastInfo.isOpen} onClose={() => setToastInfo(s => ({ ...s, isOpen: false }))} autoHideDuration={2000}>
          <Alert severity={toastInfo.isSuccess ? "success" : "error"} sx={{ width: '100%' }}> {toastInfo.msg} </Alert></Snackbar>
      </TabPanel>
    </div>
  );
};

export default CouponsTab;